module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_1_1-743e6df76da616cde1cb41fc14bf5f18.png";